import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { TellentGrantAccessEffects } from './store/tellent-grant-access.effects';
import {
  TellentGrantAccessNamespace,
  TellentGrantAccessReducer,
} from './store/tellent-grant-access.store';

const provideGrantAccessState = provideState(
  TellentGrantAccessNamespace,
  TellentGrantAccessReducer,
);
const provideGrantAccessEffects = provideEffects(TellentGrantAccessEffects);

export const tellentGrantAccessData = [provideGrantAccessState, provideGrantAccessEffects];
